import { type Brand } from '@/consts/brands';

// Kept in sync with apps/site's getBrandFromRequest so a given host resolves to
// the same brand in both. The trailing dot pins the right-hand label boundary,
// so agencyskincare.com is not treated as agency.
const AGENCY_HOSTS = ['withagency.', 'agencyskin.'];

/**
 * @deprecated
 * Gets the brand from the URL; for the cases where
 * we are not in a React component, such as the csrfHandler
 */
export const getBrandFromUrl = (): Brand => {
  const host = window?.location?.host?.toLowerCase() ?? '';
  const brand = AGENCY_HOSTS.some((agencyHost) => host.includes(agencyHost))
    ? 'agency'
    : 'curology';

  return brand as Brand;
};
